import {
  INotificationToast,
  NotificationToastBuilder,
  Variant
} from "@kernel/react-ui-kit";

export abstract class ErrorToast implements INotificationToast {
  protected builder: NotificationToastBuilder;

  constructor(protected errorMessage: string) {
    this.builder = new NotificationToastBuilder();
  }

  public toast() {
    return this.builder
      .withHeader(this.header())
      .withAutohide()
      .withIcon({
        set: "fa",
        icon: ["solid", "exclamation-triangle"]
      })
      .withDelay(2000)
      .withBody(this.errorMessage)
      .withBg(this.bg())
      .build()
      .toast();
  }

  public abstract header(): string;
  public abstract bg(): Variant;
}
